import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "input"]

  connect() {
    this.dirty = false
    this.form = this.element.querySelector("form")
    if (this.form) this.form.addEventListener("submit", this.onSubmit)

    if (this.hasFrameTarget) {
      this.frameTarget.addEventListener("load", this.onFrameLoad)
      this.scheduleFrameSetup()
    }
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("submit", this.onSubmit)
    if (this.hasFrameTarget) {
      this.frameTarget.removeEventListener("load", this.onFrameLoad)
    }
    this.sheetElement()?.removeEventListener("input", this.onInput)
    if (this.frameSetupTimer) window.clearTimeout(this.frameSetupTimer)
  }

  scheduleFrameSetup(attempt = 0) {
    if (this.prepareEditableSheet()) return
    if (attempt >= 20) return

    this.frameSetupTimer = window.setTimeout(() => this.scheduleFrameSetup(attempt + 1), 50)
  }

  onFrameLoad = () => {
    this.scheduleFrameSetup()
  }

  prepareEditableSheet() {
    const sheet = this.sheetElement()
    if (!sheet || sheet.dataset.editableReady === "true") return sheet?.dataset.editableReady === "true"

    sheet.contentEditable = "true"
    sheet.dataset.editableReady = "true"
    sheet.classList.add("outline-none", "focus-visible:ring-2", "focus-visible:ring-primary/30")
    sheet.addEventListener("input", this.onInput)

    return true
  }

  sheetElement() {
    if (!this.hasFrameTarget) return null

    return this.frameTarget.contentDocument?.querySelector(".contract-sheet")
  }

  onInput = () => {
    this.dirty = true
  }

  syncInput = () => {
    if (!this.dirty) return

    const sheet = this.sheetElement()
    if (!sheet || !this.hasInputTarget) return

    this.inputTarget.value = sheet.innerHTML
  }

  onSubmit = (event) => {
    this.syncInput()

    if (this.dirty && this.hasInputTarget && this.inputTarget.value.trim() === "") {
      event.preventDefault()
      window.alert("Contract text cannot be empty.")
    }
  }
}
